import PageTypeB from "../components/pageTypeB/PageTypeB";
import { pagesDataB } from "../data/pagesData";

const Page5 = () => {
  return (
    <PageTypeB
      title={pagesDataB[2].title}
      paragraph1={pagesDataB[2].paragraph1}
      paragraph2={pagesDataB[2].paragraph2}
      paragraph3={pagesDataB[2].paragraph3}
    />
  );
};

export default Page5;
